import { Callback } from 'Src/types/utilTypes'
import {
	SocketMessage,
	SocketChannel,
	BgLimitRequestChannel,
	LeadChannel,
	NotificationChannel,
	ReserveOrderChannel,
	BankGuaranteeChannelNeo,
	AdvertisementChannel,
	FrontChannel,
	PartnerContractChannel,
	ReportStateChannel,
	RbidosRequestChannel,
	CustomerIdentificationChannel,
} from 'Modules/Socket'

const getChannelName = (data: SocketMessage) => {
	if (data?.identifier) return JSON.parse(data.identifier)?.channel as string
	return null
}

export const channelHandlerFactory = (dispatch: Callback) => {
	const channels = {
		[SocketChannel.LEAD_CHANNEL]: new LeadChannel(dispatch),
		[SocketChannel.NOTIFY_CHANNEL]: new NotificationChannel(dispatch),
		[SocketChannel.RESERVE_ACCOUNT_CHANNEL]: new ReserveOrderChannel(dispatch),
		[SocketChannel.BG_LIMIT_REQUEST_CHANNEL]: new BgLimitRequestChannel(dispatch),
		[SocketChannel.BG_REQUEST_CHANNEL]: new BankGuaranteeChannelNeo(dispatch),
		[SocketChannel.ORD_CHANNEL]: new AdvertisementChannel(dispatch),
		[SocketChannel.FRONT_CHANNEL]: new FrontChannel(dispatch),
		[SocketChannel.PARTNER_CONTRACT_CHANNEL]: new PartnerContractChannel(dispatch),
		[SocketChannel.REPORT_STATE_CHANNEL]: new ReportStateChannel(dispatch),
		[SocketChannel.RBIDOS_REQUEST_CHANNEL]: new RbidosRequestChannel(dispatch),
		[SocketChannel.CUSTOMER_IDENTIFICATION_CHANNEL]: new CustomerIdentificationChannel(dispatch),
	}

	return (data: SocketMessage) => channels[getChannelName(data)]?.work(data)
}
